import { render, staticRenderFns } from "./FormFaq.vue?vue&type=template&id=df5f4f54&scoped=true"
import script from "./FormFaq.vue?vue&type=script&lang=js"
export * from "./FormFaq.vue?vue&type=script&lang=js"
import style0 from "./FormFaq.vue?vue&type=style&index=0&id=df5f4f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5f4f54",
  null
  
)

export default component.exports